import { getSearchUiState } from '@/redux/modules/search/search.selectors';
import { getUserExcludedHouses } from '@/redux/modules/search/exclusions/searchExclusions.selectors';
import { SearchPageName, SearchQuery, SearchQueryStatus } from '@/types/search/searchQuery';
import { submitSearch } from '@/redux/modules/search/search.actions';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useCallback, useEffect, useState } from 'react';
import { useElasticVsAlgoliaKeywordSearchExperiment } from '@/utils/amplitude/experiments/hooks/useElasticVsAlgoliaKeywordSearchExperiment';

type Props = {
    searchQuery: SearchQuery;
};

export const useHandleRefetchOnExcludedHouse = ({ searchQuery }: Props) => {
    const userExcludedHouses = useAppSelector(getUserExcludedHouses);
    const [initialHouses, setInitialHouses] = useState<number[]>(userExcludedHouses);
    const dispatch = useAppDispatch();
    const pageName = searchQuery.options.status.includes(SearchQueryStatus.Sold)
        ? SearchPageName.SOLD_SEARCH
        : SearchPageName.SEARCH;
    const { submitted: isLoadingSearchResults } = useAppSelector(getSearchUiState);

    const { hasElasticVsAlgoliaKeywordSearchTreatment } = useElasticVsAlgoliaKeywordSearchExperiment();

    const submitNewSearch = useCallback(() => {
        dispatch(submitSearch({ pageName, searchQuery, useATGSearch: hasElasticVsAlgoliaKeywordSearchTreatment }));
    }, [dispatch, pageName, searchQuery, hasElasticVsAlgoliaKeywordSearchTreatment]);

    // Track initial houses on mount
    useEffect(() => {
        setInitialHouses(userExcludedHouses);
    }, [userExcludedHouses]);

    // Compare current houses with initial houses
    useEffect(() => {
        const hasNewExclusions = userExcludedHouses.length > initialHouses.length;

        if (hasNewExclusions && !isLoadingSearchResults) {
            submitNewSearch();
        }
    }, [initialHouses.length, isLoadingSearchResults, submitNewSearch, userExcludedHouses.length]);
};
